import Vue from 'vue'
import ComHeader from './comHeader' // 头部
import ComFooter from './comFooter' // 底部
import ComAside from './comAside'   // 侧边导航栏
import ComPopover from './conPopover' // 密码验证
import comUiMore from './moreInfo'; // 列表文本更多信息显示


Vue.component('com-header', ComHeader)
Vue.component('com-footer', ComFooter)
Vue.component('com-aside', ComAside)
Vue.component('com-popover', ComPopover)
Vue.component('com-more', comUiMore);



// WEBPACK FOOTER //
// ./src/components/index.js